import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import { SITE } from "@/config/site";

const MAP_CLASS =
  "z-0 h-[380px] w-full overflow-hidden rounded-3xl border border-ink/10 sm:h-[440px]";
const MAP_LABEL =
  "Mappa interattiva con le tre sedi di Nutrimove Lab: Bologna e Casalecchio di Reno";

// Un'unica mappa con TRE marker: Leaflet + OpenStreetMap,
// geocoding reale degli indirizzi via Nominatim. Nessuna chiave API richiesta.
export default function StudioMap() {
  const containerRef = useRef(null);

  useEffect(() => {
    delete L.Icon.Default.prototype._getIconUrl;
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: markerIcon2x,
      iconUrl: markerIcon,
      shadowUrl: markerShadow,
    });

    const map = L.map(containerRef.current, { scrollWheelZoom: false });
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap</a> contributors',
      maxZoom: 19,
    }).addTo(map);

    let cancelled = false;
    Promise.all(
      SITE.locations.map((loc) =>
        fetch(
          `https://nominatim.openstreetmap.org/search?format=json&limit=1&q=${encodeURIComponent(loc.query)}`
        )
          .then((r) => r.json())
          .then((res) => ({ loc, res }))
          .catch(() => ({ loc, res: null }))
      )
    ).then((results) => {
      if (cancelled) return;
      const points = [];
      results.forEach(({ loc, res }) => {
        if (res && res[0]) {
          const latLng = [parseFloat(res[0].lat), parseFloat(res[0].lon)];
          points.push(latLng);
          L.marker(latLng)
            .addTo(map)
            .bindPopup(`<strong>${loc.city}</strong><br/>${loc.lines.join("<br/>")}`);
        }
      });
      if (points.length > 0) {
        map.fitBounds(points, { padding: [48, 48], maxZoom: 13 });
      } else {
        map.setView([44.472, 11.275], 12);
      }
    });

    return () => {
      cancelled = true;
      map.remove();
    };
  }, []);

  return (
    <div
      ref={containerRef}
      data-testid="studio-map"
      role="application"
      aria-label={MAP_LABEL}
      className={MAP_CLASS}
    />
  );
}
